import React, { useState, useEffect } from 'react';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import {
    GET_CLASS_BOOMBASSADORS,
    GET_BOOMBASADORS_WEEKLY_STATS,
} from './graphql';
import headerStyles from '../StudentTileList/StudentTileList.module.scss';
import styles from './BoomBassadors.module.scss';
import { Dropdown, Modal, Button } from '@squirrellearningltd/go-teacher-components';
import gem from '../../../../components/GemButton/images/gem-green.svg';
import Boomer from '../../../../images/loader-boomer.png';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { STUDENTS_AWARD_GEM_MUTATION } from '../../../../components/GemButton/services/graphql';
import { SET_STUDENTS_FLAG } from '../../services/graphql';
import { FLAGS, getFlagColor } from '../../../../utils/constants';
import * as Icon from 'react-feather';
import WeekPicker from '../../../Shared/WeekPicker';
import moment from 'moment';
import { Link } from '@reach/router';

const BoomBassadorsOverview = ({ classId, weekStart, getStartOfWeek }) => {
    const { t } = useTranslation();
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [boomBassadorWeekStart, setBoombassadorStatsWeekStart] = useState(
        getStartOfWeek(weekStart)
    );

    const [
        getClassBoombassadors,
        {
            data: classDataBoombassadorsData,
            loading: classDataBoombassadorsLoading,
            error: classDataBoombassadorsError,
        },
    ] = useLazyQuery(GET_CLASS_BOOMBASSADORS, {
        fetchPolicy: 'network-only',
        variables: {
            studentsClassId: classId,
            startDate: moment(boomBassadorWeekStart).format('DD-MM-YYYY'),
            endDate: moment(boomBassadorWeekStart)
                .add(7, 'days')
                .format('DD-MM-YYYY'),
        },
    });

    const [
        getClassBoombassadorsWeeklyStats,
        {
            data: classBoombassadorsWeeklyStats,
            loading: classBoombassadorsWeeklyStatsLoading,
            error: classBoombassadorsWeeklyStatsError,
        },
    ] = useLazyQuery(GET_BOOMBASADORS_WEEKLY_STATS, {
        fetchPolicy: 'network-only',
        variables: {
            id: classId,
            startDate: moment(boomBassadorWeekStart).format('DD-MM-YYYY'),
            endDate: moment(boomBassadorWeekStart)
                .add(7, 'days')
                .format('DD-MM-YYYY'),
        },
    });

    useEffect(() => {
        if (classId && boomBassadorWeekStart) {
            getClassBoombassadors();
            getClassBoombassadorsWeeklyStats();
        }
    }, [boomBassadorWeekStart, classId]);

    const onSelectAllStudents = (e) => {
        const stIds = classDataBoombassadorsData.getClassBoombassadors.map(
            (student) => student.id
        );
        e.target.checked ? setSelectedStudents(stIds) : setSelectedStudents([]);
    };

    const [gemAwards, setGemAwards] = useState({
        modal: false,
        awarded: false,
    });

    const [awardGems, { loading }] = useMutation(STUDENTS_AWARD_GEM_MUTATION, {
        variables: {
            studentIds: selectedStudents,
        },
        onCompleted: ({ addRewardGemToStudents }) => {
            if (
                addRewardGemToStudents.errors &&
                addRewardGemToStudents.errors.length !== 0
            ) {
                alert(t('error_awarding_gem'));
                return;
            }
            if (addRewardGemToStudents.studentIds) {
                setGemAwards({ ...gemAwards, awarded: true });
                setSelectedStudents([]);
            }
        },
    });

    const flagOptions = classDataBoombassadorsData
        ? [
              ...FLAGS.map((flag) => {
                  return {
                      text: (
                          <span className='u-display-flex u-align-center light'>
                              <Icon.Flag
                                  size='20'
                                  fill={flag.color}
                                  color={flag.color}
                                  className={cx(styles.flagBtn, 'u-m-right-1')}
                              />{' '}
                              {flag.name}
                          </span>
                      ),
                      action: () => flagMultipleStudents(flag.type, false),
                  };
              }),
              {
                  text: (
                      <span className='u-display-flex u-align-center light'>
                          <Icon.Flag
                              size='20'
                              color={'#ccc'}
                              className={cx(styles.flagBtn, 'u-m-right-1')}
                          />{' '}
                          Un-flag
                      </span>
                  ),
                  action: () => flagMultipleStudents(null, true),
              },
          ]
        : [];

    const [setStudentsFlag] = useMutation(SET_STUDENTS_FLAG, {
        onCompleted: ({ setStudentsFlag }) => {
            if (setStudentsFlag.students) {
                setSelectedStudents([]);
            }
        },
    });

    const flagMultipleStudents = (type, remove) => {
        setStudentsFlag({
            variables: {
                studentIds: selectedStudents,
                flagType: type,
                removeFlags: remove,
            },
        });
    };

    return (
        <>
            <BoomBassadorOverviewHeader
                t={t}
                selectedStudents={selectedStudents}
                classDataBoombassadorsData={classDataBoombassadorsData}
                onSelectAllStudents={onSelectAllStudents}
                gemAwards={gemAwards}
                setGemAwards={setGemAwards}
                flagOptions={flagOptions}
                weekStart={weekStart}
                boomBassadorWeekStart={boomBassadorWeekStart}
                setBoombassadorStatsWeekStart={setBoombassadorStatsWeekStart}
                getStartOfWeek={getStartOfWeek}
            ></BoomBassadorOverviewHeader>

            {classDataBoombassadorsLoading && <p>Loading...</p>}
            {classDataBoombassadorsError && (
                <p>{classDataBoombassadorsError.message}</p>
            )}
            {classDataBoombassadorsData && (
                <>
                    <>
                        {classDataBoombassadorsData?.getClassBoombassadors
                            ?.length ? (
                            <BoomBassadorsOverviewContent
                                boomBasadors={
                                    classDataBoombassadorsData?.getClassBoombassadors
                                }
                                selectedStudents={selectedStudents}
                                setSelectedStudents={setSelectedStudents}
                                classBoombassadorsWeeklyStats={
                                    classBoombassadorsWeeklyStats
                                }
                                classBoombassadorsWeeklyStatsLoading={
                                    classBoombassadorsWeeklyStatsLoading
                                }
                                classBoombassadorsWeeklyStatsError={
                                    classBoombassadorsWeeklyStatsError
                                }
                            />
                        ) : (
                            <div>
                                <div
                                    className={
                                        styles.manageBoomBassadorDisclaimer
                                    }
                                >
                                    <div>
                                        <Icon.Info size={30} color={'#fff'} />
                                    </div>
                                    <div>
                                        Your class doesn’t currently have any
                                        Boombassadors. To assign a reading
                                        ambassador, please contact your school
                                        admin. They can promote a Boombassador
                                        for your class in the BoomReader
                                        settings.
                                    </div>
                                </div>
                                <div
                                    className={styles.manageBoomBassadorDetails}
                                >
                                    <h3>What is a BoomBassasdor?</h3>
                                    <p>
                                        A BoomBassasdor is a student reading
                                        ambassador chosen by you to help record
                                        reading for other students in their
                                        class or school.
                                    </p>

                                    <h4>BoomBassasdors can:</h4>
                                    <ul>
                                        <li>
                                            Search for students in their class
                                            or across the school.
                                        </li>
                                        <li>
                                            Add reading logs for other students
                                            in the BoomReader platform.
                                        </li>
                                        <li>
                                            Earn rewards for regularly logging
                                            reading activity in their school.
                                        </li>
                                    </ul>

                                    <h4>BoomBassasors cannot:</h4>
                                    <ul>
                                        <li>
                                            Delete or edit existing reading
                                            records on another student's
                                            account.
                                        </li>
                                        <li>
                                            View, read, or contribute to teacher
                                            comments or private notes.
                                        </li>
                                        <li>
                                            Add new books for other students.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        )}
                    </>

                    {gemAwards.modal && (
                        <Modal
                            closeModal={() => {
                                setGemAwards({ modal: false, awarded: false });
                                setSelectedStudents([]);
                            }}
                        >
                            <h2 className='u-m-base-4 u-text-center'>
                                {t('award_gem_to_multiple_pupils')}
                            </h2>
                            {gemAwards.awarded ? (
                                <Button
                                    onClick={() =>
                                        setGemAwards({
                                            modal: false,
                                            awarded: false,
                                        })
                                    }
                                    outline
                                    className={styles.gemButton}
                                >
                                    <Icon.CheckCircle /> {t('done')}!
                                </Button>
                            ) : (
                                <Button
                                    outline
                                    className={styles.gemButton}
                                    onClick={() => awardGems()}
                                >
                                    <img src={gem} alt='' />
                                    {loading
                                        ? t('loading')
                                        : t('award_bonus_gem')}
                                </Button>
                            )}
                        </Modal>
                    )}
                </>
            )}
        </>
    );
};

// Components
function BoomBassadorOverviewHeader(props) {
    return (
        <div className={cx(headerStyles.classActionsSub, 'hidden-print')}>
            <div className={headerStyles.classActionsSelectAll}>
                <div
                    className={cx(
                        'basic-form__group--check',
                        headerStyles.stCheck
                    )}
                >
                    <input
                        name='all'
                        className='basic-form__check-box'
                        type='checkbox'
                        checked={
                            props.selectedStudents?.length ===
                            props.classDataBoombassadorsData
                                ?.getClassBoombassadors?.length
                        }
                        onChange={(e) => props.onSelectAllStudents(e)}
                        id='selectAll'
                    />
                    <label
                        className='basic-form__check-label'
                        htmlFor='selectAll'
                    >
                        &nbsp;
                    </label>
                </div>

                <button
                    onClick={() => {
                        props.setGemAwards({ ...props.gemAwards, modal: true });
                    }}
                    disabled={!props.selectedStudents.length}
                    className={cx(
                        headerStyles.classActionsLink,
                        headerStyles.classActionsLinkIcon,
                        'u-m-left-2'
                    )}
                >
                    <img src={gem} className='u-m-right-1' alt='' /> Bonus
                </button>

                <Dropdown
                    titleRight={props.t('flag')}
                    leftAligned
                    icon={Icon.Flag}
                    dropdownOpts={props.flagOptions}
                    classNames={cx(
                        headerStyles.classActionsLink,
                        headerStyles.classActionsLinkFlag,
                        {
                            [headerStyles.classActionsLinkDisabled]:
                                props.selectedStudents.length === 0,
                        }
                    )}
                />

                <div className={styles.readingTargetsPicker}>
                    <span
                        className={cx(styles.classActionsLink, 'u-m-right-2')}
                    >
                        Select Week
                    </span>
                    <WeekPicker
                        startDay={props.weekStart}
                        maxDate={props.getStartOfWeek(props.weekStart)}
                        weekStartDate={props.boomBassadorWeekStart}
                        setWeekStartDate={props.setBoombassadorStatsWeekStart}
                    />
                </div>
            </div>
        </div>
    );
}

function BoomBassadorsOverviewContent({
    boomBasadors,
    selectedStudents,
    setSelectedStudents,
    classBoombassadorsWeeklyStatsLoading,
    classBoombassadorsWeeklyStats,
    classBoombassadorsWeeklyStatsError,
}) {
    const [leaderBoard, setLeaderBoard] = useState([]);
    const toggleSelectedStudent = (boomBassadorId) => {
        if (selectedStudents.indexOf(boomBassadorId) !== -1) {
            setSelectedStudents(
                selectedStudents.filter((s) => s !== boomBassadorId)
            );
        } else {
            setSelectedStudents([...selectedStudents, boomBassadorId]);
        }
    };

    useEffect(() => {
        if (boomBasadors) {
            const copyOfBoombassadors = [...boomBasadors];
            setLeaderBoard(
                copyOfBoombassadors.sort(
                    (a, b) =>
                        a.readsLogged.readsLogged < b.readsLogged.readsLogged
                )
            );
        }
    }, [boomBasadors]);

    if (classBoombassadorsWeeklyStatsLoading) {
        return 'Loading';
    }

    if (classBoombassadorsWeeklyStatsError) {
        return classBoombassadorsWeeklyStatsError.message;
    }

    return (
        <div className={styles.dashboardContainer}>
            <div className={styles.studentsSection}>
                <div className={styles.studentsHeader}>
                    <div className={styles.checkbox}></div>
                    <div className={styles.name}>Student Name</div>
                    <div className={styles.reads}>Reads Logged</div>
                    <div className={styles.last}>Last Logged</div>
                    <div className={styles.permission}>Permission Level</div>
                </div>

                {boomBasadors.map((boomBasador) => (


                    <div key={boomBasador.id} className={styles.studentRow}>
                        <Link className={styles.rowLink} to={`/student/${boomBasador.id}`}></Link>

                        <div className={styles.checkbox}>
                            <div
                                className={cx(
                                    'basic-form__group--check',
                                    styles.stCheck
                                )}
                            >
                                <input
                                    name='all'
                                    className='basic-form__check-box'
                                    type='checkbox'
                                    checked={selectedStudents.includes(
                                        boomBasador.id
                                    )}
                                    onChange={() =>
                                        toggleSelectedStudent(boomBasador.id)
                                    }
                                    id={boomBasador.id}
                                />
                                <label
                                    className='basic-form__check-label'
                                    htmlFor={boomBasador.id}
                                >
                                    &nbsp;
                                </label>
                            </div>
                        </div>
                        <div className={styles.name}>
                            <img
                                src={
                                    boomBasador.boomerAvatarUrl
                                        ? `${
                                              boomBasador.boomerAvatarUrl
                                          }?v=${boomBasador.updatedAt.replace(
                                              /\s/g,
                                              ''
                                          )}`
                                        : Boomer
                                }
                                style={{
                                    width: '6rem',
                                }}
                            />
                            {boomBasador.flagType && (
                                <span
                                    style={{
                                        background: getFlagColor(
                                            boomBasador.flagType
                                        ),
                                    }}
                                    className={styles.studentFlag}
                                >
                                    <Icon.Flag
                                        fill='#fff'
                                        color='#fff'
                                        size='14'
                                    />
                                </span>
                            )}
                            <span className={styles.firstAndLastNameContainer}>
                                {boomBasador.firstName} {boomBasador.lastName}
                            </span>
                        </div>
                        <div className={styles.reads}>
                            {boomBasador.readsLogged?.readsLogged || 0}
                        </div>
                        <div className={styles.last}>
                            {boomBasador.readsLogged?.lastLogged || '-'}
                        </div>
                        <div className={styles.permission}>School</div>
                    </div>

                ))}
            </div>
            <div className={styles.rightPanel}>
                <div className={styles.statsCard}>
                    <h2>Stats</h2>
                    <div className={`${styles.statBox} ${styles.green}`}>
                        <p>Number of ambassadors</p>
                        <span>
                            {
                                classBoombassadorsWeeklyStats?.studentsClass
                                    .boombassadorWeeklyStats
                                    .numberOfBoombassadors
                            }
                        </span>
                    </div>
                    <div className={`${styles.statBox} ${styles.purple}`}>
                        <p>Reads logged this week</p>
                        <span>
                            {
                                classBoombassadorsWeeklyStats?.studentsClass
                                    .boombassadorWeeklyStats.statsPerWeek
                            }
                        </span>
                    </div>
                </div>

                <div className={styles.leaderboardCard}>
                    <h2>Leaderboard</h2>
                    <p className={styles.subtext}>
                        This week’s top Boombassadors
                    </p>
                    <ol>
                        {leaderBoard?.map((boomBassador, i) => (
                            <li key={boomBassador.id}>
                                <img
                                    src={
                                        boomBassador.boomerAvatarUrl
                                            ? `${
                                                  boomBassador.boomerAvatarUrl
                                              }?v=${boomBassador.updatedAt.replace(
                                                  /\s/g,
                                                  ''
                                              )}`
                                            : Boomer
                                    }
                                    style={{
                                        width: '50px',
                                    }}
                                />
                                {i + 1}. {boomBassador.firstName}{' '}
                                {boomBassador.lastName}
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </div>
    );
}

export default BoomBassadorsOverview;
